import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminGuard } from 'src/app/shared/guard/admin.guard';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ExtratoComponent } from './extrato/extrato/extrato.component';
import { AccountComponent } from './account/account/account.component';
import { ViewAccountComponent } from './account/view-account/view-account.component';
import { CryptomoedaComponent } from './cryptomoeda/cryptomoeda.component';
import { DepositComponent } from './deposit/deposit/deposit/deposit.component';
import { DepositPixComponent } from './deposit/depositPix/depositPix/depositPix.component';
import { CashInComponent } from './deposit/cashIn/cashIn/cashIn.component';
import { TransferenciaComponent } from './transferencia/transferencia/transferencia/transferencia.component';
import { SaqueCopiaColaComponent } from './transferencia/saque-copia-cola/saque-copia-cola/saque-copia-cola.component';
import { TransferBalanceComponent } from './transfer-balance/transfer-balance.component';
import { WalletComponent } from './wallet/wallet.component';
import { WebhookComponent } from './webhook/webhook.component';
import { ApproveComponent } from './withdraw/approve/approve.component';
import { ApproveadminComponent } from './withdraw/approveadmin/approveadmin.component';
import { ContentLayoutComponent } from '../shared/layout-components/layout/content-layout/content-layout.component';
import { OriginGuard } from '../shared/guard/origin.guard';
import { ReservaGgrComponent } from './reserva-ggr/reserva-ggr/reserva-ggr.component';
import { ReserveAccountGuard } from '../shared/guard/reserve-account.guard';

// const isDesktop(): boolean => {
//   return navigator.orientation === undefined;
// }

const routes: Routes = [
  {
    path: '',
    component: ContentLayoutComponent,
    children: [
      {
        path: '',
        data: { mode: 'dark' },
        loadChildren: () =>
          import('./home/home.module').then((m) => m.HomeModule),
      },
      {
        path: '',
        loadChildren: () =>
          import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: 'extrato',
        title: 'Extrato',
        component: ExtratoComponent,
        canActivate: [AdminGuard],
      },
      {
        path: 'reserva-ggr',
        title: 'Reserva GGR',
        component: ReservaGgrComponent,
        canActivate: [AdminGuard, ReserveAccountGuard],
      },
      {
        path: 'transferencia',
        title: 'Transferência',
        component: TransferenciaComponent,
        canActivate: [AdminGuard, OriginGuard],
        data: { allowedOrigins: ['BRL'] }
      },
      {
        path: 'saque-copia-cola',
        title: 'Saque Copia e Cola',
        component: SaqueCopiaColaComponent,
        canActivate: [AdminGuard, OriginGuard],
        data: { allowedOrigins: ['BRL'] }
      },
      {
        path: 'transfer-balance',
        title: 'Transferir Saldo',
        component: TransferBalanceComponent,
        canActivate: [AdminGuard],
      },
      {
        path: 'criptomoeda',
        title: 'Criptoativos',
        component: CryptomoedaComponent,
        canActivate: [AdminGuard],
      },
      {
        path: 'deposito',
        title: 'Depósito',
        component: DepositComponent,
        canActivate: [AdminGuard, OriginGuard],
        data: { allowedOrigins: ['BRL'] }
      },
      {
        path: 'depositoPix',
        title: 'Depósito Pix',
        component: DepositPixComponent,
        canActivate: [AdminGuard, OriginGuard],
        data: { allowedOrigins: ['BRL'] }
      },
      {
        path: 'cashIn',
        title: 'Cash In',
        component: CashInComponent,
        canActivate: [AdminGuard, OriginGuard],
        data: { excludedOrigins: ['BRL'] }
      },
      {
        path: 'account/view',
        title: 'Visualização da Conta',
        component: ViewAccountComponent,
        canActivate: [AdminGuard],
      },
      {
        path: 'wallet',
        title: 'Carteira',
        component: WalletComponent,
        canActivate: [AdminGuard],
      },
      {
        path: 'account/account',
        title: 'Contas',
        component: AccountComponent,
        canActivate: [AdminGuard],
      },
      {
        path: 'webhook',
        title: 'WebHook',
        component: WebhookComponent,
        canActivate: [AdminGuard],
      },
      {
        path: 'approve-withdraw',
        title: 'Aprovar Saques',
        component: ApproveComponent,
        canActivate: [AdminGuard],
      },
      {
        path: 'approve-withdraw-admin',
        title: 'Aprovar Saques',
        component: ApproveadminComponent,
        canActivate: [AdminGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],

  exports: [RouterModule],
})
export class ComponentsRouteModule {}
